import { render, staticRenderFns } from "./TopBarTitle.vue?vue&type=template&id=34482d6f&"
import script from "./TopBarTitle.vue?vue&type=script&lang=ts&"
export * from "./TopBarTitle.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})


/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('34482d6f')) {
      api.createRecord('34482d6f', component.options)
    } else {
      api.reload('34482d6f', component.options)
    }
    module.hot.accept("./TopBarTitle.vue?vue&type=template&id=34482d6f&", function () {
      api.rerender('34482d6f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/navigation/TopBarTitle.vue"
export default component.exports